import axios from "axios"

export default {
  saveCanvas(canvas) {
    return axios.post(`/v1/canvas`, canvas);
  },
  getCanvases(teamid) {
    return axios.get(`/v1/team/canvas/${teamid}`)
  },
  getCanvas(canvasid) {
    return axios.get(`/v1/canvas/${canvasid}`)
  },
  getCanvasPrefilled(canvasid) {
    return axios.get(`/v1/prefilled/canvas/${canvasid}`)
  },
  getStudentCanvases(studentID, sectionID) {
    return axios.get(`/v1/canvases/student/${studentID}/${sectionID}`)
  },
  getSectionCanvases(sectionID) {
    return axios.get(`/v1/canvases/section/${sectionID}`)
  },
  getSectionCanvasesPrefilled(sectionID) {
    return axios.get(`/v1/canvases/prefilled/${sectionID}`)
  },
  getSectionCanvasFeedbacks(sectionID) {
    return axios.get(`/v1/canvases/feedback/${sectionID}`)
  },
  getContextCanvasesPrefilled() {
    return axios.get(`/v1/context/canvases/prefilled`)
  },
  getContextCanvasFeedbacks() {
    return axios.get(`/v1/context/canvas/feedback`)
  },
  submitFeedback(feedback) {
    return axios.post(`/v1/context/canvas/feedback`, feedback)
  },
  attachFile(teamID, assignmentID, topic, data) {
    return axios.post(`/v1/attachment/canvas/${teamID}/${assignmentID}/${topic}`, data)
  },
  removeAttachment(teamID, assignmentID, topic) {
    return axios.delete(`/v1/attachment/canvas/${teamID}/${assignmentID}/${topic}`)
  },
  getAttachment(teamID, assignmentID, topic) {
    return axios.get(`/v1/attachment/canvas/${teamID}/${assignmentID}/${topic}`)
  }
}